import { CameraOff, Loader2 } from 'lucide-react';

// Shown above the screenshot blur while a learner who tried to take a screenshot is signed out
export const ScreenshotBlockedOverlay = ({ attemptLabel }) => (
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-background/80 p-6 backdrop-blur-2xl"
        data-testid="screenshot-blocked-overlay" onContextMenu={(e) => e.preventDefault()}>
        <div className="w-full max-w-md space-y-5 rounded-3xl border border-red-500/30 bg-card/95 p-8 text-center shadow-2xl">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/10 text-red-500">
                <CameraOff className="h-7 w-7" />
            </div>
            <h2 className="font-heading text-2xl font-bold">Screenshot blocked</h2>
            <p className="text-sm text-muted-foreground" data-testid="screenshot-blocked-message">
                Screenshots are not allowed. You are being signed out{attemptLabel ? ` and your ${attemptLabel} has been ended` : ''}.
            </p>
            <p className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
                <Loader2 className="h-3.5 w-3.5 animate-spin" />Signing you out
            </p>
        </div>
    </div>
);
